// src/pages/Ranking.js (오류 수정 및 협회 계정 제외)
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

function Ranking() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("볼링");
  const [bowlingRanking, setBowlingRanking] = useState([]);
  const [guildRanking, setGuildRanking] = useState([]);
  const [loading, setLoading] = useState(false);
  const [myId, setMyId] = useState(null);

  // 사용자 정보 로드
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setMyId(user?.id);
  }, []);

  // 볼링 랭킹 데이터 가져오기
  useEffect(() => {
    if (selectedTab !== "볼링") return;
    
    setLoading(true);
    async function fetchBowlingRanking() {
      try {
        // 1. 모든 사용자 불러오기 (협회 계정 제외)
        const usersSnap = await getDocs(collection(db, "users"));
        const users = usersSnap.docs
          .map(doc => ({ 
            id: doc.id, 
            ...doc.data() 
          }))
          .filter(user => user.userType !== 'association'); // 협회 계정 제외

        // 2. 볼링 기록 불러오기
        const bowlingQuery = query(
          collection(db, "sportsRecords"),
          where("sport", "==", "볼링")
        );
        const bowlingSnap = await getDocs(bowlingQuery);
        const bowlingRecords = bowlingSnap.docs.map(doc => doc.data());

        // 3. 닉네임별로 볼링 기록 맵핑
        const bowlingRecordsMap = {};
        bowlingRecords.forEach(record => {
          const nickname = record.nickname || record.userNickname;
          if (nickname) {
            if (!bowlingRecordsMap[nickname]) {
              bowlingRecordsMap[nickname] = {
                mmr: 0,
                win: 0,
                lose: 0,
                totalScore: 0,
                totalGames: 0,
                highScore: 0
              };
            }
            const existing = bowlingRecordsMap[nickname];
            existing.mmr = Math.max(existing.mmr, record.mmr || 0);
            existing.win += record.win || 0;
            existing.lose += record.lose || 0;
            existing.totalScore += record.totalScore || 0;
            existing.totalGames += record.totalGames || 0;
            existing.highScore = Math.max(existing.highScore, record.highScore || 0);
          }
        });

        // 평균 점수 계산
        Object.keys(bowlingRecordsMap).forEach(nickname => {
          const record = bowlingRecordsMap[nickname];
          record.averageScore = record.totalGames > 0 ? 
            Math.round(record.totalScore / record.totalGames) : 0;
        });

        // 4. 유저별로 볼링 기록 합치기
        let allRows = users.map(user => {
          const nickname = user.nickname || user.id;
          const record = bowlingRecordsMap[nickname];
          return {
            id: user.id,
            nickname: nickname,
            mmr: record ? record.mmr : 0,
            win: record ? record.win : 0,
            lose: record ? record.lose : 0,
            averageScore: record ? record.averageScore : 0,
            highScore: record ? record.highScore : 0,
            totalGames: record ? (record.win + record.lose) : 0
          };
        });

        // 5. MMR순 정렬, 동점은 닉네임순
        allRows.sort((a, b) => {
          if (b.mmr !== a.mmr) return b.mmr - a.mmr;
          return a.nickname.localeCompare(b.nickname);
        });

        setBowlingRanking(allRows);
      } catch (error) {
        console.error("볼링 랭킹 로딩 실패:", error);
        setBowlingRanking([]);
      }
      setLoading(false);
    }
    fetchBowlingRanking();
  }, [selectedTab]);

  // 길드 랭킹 데이터 가져오기
  useEffect(() => {
    if (selectedTab !== "길드랭킹") return;
    
    setLoading(true);
    async function fetchGuildRanking() {
      try {
        const guildsSnap = await getDocs(collection(db, "guilds"));
        let guilds = guildsSnap.docs.map(doc => ({ 
          id: doc.id, 
          ...doc.data() 
        }));

        // 각 길드의 멤버 수 계산
        const guildMembersSnap = await getDocs(collection(db, "guildMembers"));
        const memberCounts = {};
        guildMembersSnap.docs.forEach(doc => {
          const guildData = doc.data();
          const guildId = guildData.guildId;
          if (guildId) {
            memberCounts[guildId] = (memberCounts[guildId] || 0) + 1;
          }
        });

        // 길드에 멤버 수 추가
        guilds = guilds.map(guild => ({
          ...guild,
          memberCount: memberCounts[guild.id] || 0
        }));

        // 길드 점수순 정렬
        guilds.sort((a, b) => (b.point || 0) - (a.point || 0));

        setGuildRanking(guilds);
      } catch (error) {
        console.error("길드 랭킹 로딩 실패:", error);
        setGuildRanking([]);
      }
      setLoading(false);
    }
    fetchGuildRanking();
  }, [selectedTab]);

  // 내 볼링 랭킹 계산
  const myBowlingRankIdx = bowlingRanking.findIndex(row => row.id === myId);

  // 길드 소개 페이지로 이동하는 함수
  const handleGuildClick = (guildId) => {
    navigate(`/guild/intro/${guildId}`);
  };

  return (
    <div style={{
      maxWidth: 750, margin: "40px auto",
      background: "#fff", borderRadius: 20, boxShadow: "0 6px 24px #e2e8f0", padding: 36
    }}>
      <div style={{
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        marginBottom: 28
      }}>
        <h2 style={{ 
          fontWeight: 900, 
          color: "#2d8cf0", 
          fontSize: 28,
          margin: 0,
          display: "flex",
          alignItems: "center",
          gap: 12
        }}>
          🏆 랭킹
        </h2>
        {selectedTab === "볼링" && myBowlingRankIdx !== -1 && (
          <button
            onClick={() => {
              const elem = document.getElementById("myRankingRow");
              if (elem) elem.scrollIntoView({ behavior: "smooth", block: "center" });
            }}
            style={{
              background: "linear-gradient(135deg, #667eea, #764ba2)",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              padding: "8px 16px",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
              boxShadow: "0 2px 8px rgba(102,126,234,0.3)"
            }}
          >
            내 순위 보기 ({myBowlingRankIdx + 1}위)
          </button>
        )}
      </div>

      <div style={{
        display: "flex",
        gap: 8,
        marginBottom: 32,
        background: "#f8fafc",
        borderRadius: 16,
        padding: 8
      }}>
        {["볼링", "길드랭킹"].map(tab => (
          <button
            key={tab}
            onClick={() => setSelectedTab(tab)}
            style={{
              flex: 1,
              background: selectedTab === tab 
                ? "linear-gradient(135deg, #3b82f6, #1d4ed8)" 
                : "transparent",
              color: selectedTab === tab ? "#fff" : "#64748b",
              border: "none",
              borderRadius: 12,
              padding: "12px 20px",
              fontSize: 16,
              fontWeight: 700,
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: selectedTab === tab 
                ? "0 4px 16px rgba(33,150,243,0.3)" 
                : "0 2px 8px rgba(0,0,0,0.05)",
              transform: selectedTab === tab ? "translateY(-2px)" : "translateY(0)"
            }}
          >
            {tab === "볼링" ? "🎳 볼링 랭킹" : "🏰 길드 랭킹"}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ 
          textAlign: "center", 
          padding: 60, 
          color: "#94a3b8",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16
        }}>
          <div style={{
            width: 40,
            height: 40,
            border: "4px solid #f1f5f9",
            borderTop: "4px solid #3b82f6",
            borderRadius: "50%",
            animation: "spin 1s linear infinite"
          }}></div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>랭킹 데이터를 불러오는 중...</div>
        </div>
      ) : (
        <>
          {/* 볼링 랭킹 테이블 */}
          {selectedTab === "볼링" && (
            <div style={{ marginBottom: 20 }}>
              <div style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                padding: "16px 20px",
                borderRadius: "16px 16px 0 0",
                textAlign: "center",
                fontWeight: 700,
                fontSize: 18
              }}>
                🎳 볼링 개인 랭킹
              </div>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                background: "#fafcff",
                borderRadius: "0 0 16px 16px",
                overflow: "hidden",
                boxShadow: "0 4px 16px rgba(0,0,0,0.1)"
              }}>
                <thead>
                  <tr style={{ 
                    background: "linear-gradient(135deg, #f0f6fd, #e3f2fd)", 
                    color: "#1565c0" 
                  }}>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>순위</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>닉네임</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>티어</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>MMR</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>승</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>패</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>승률(%)</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>평균점수</th>
                    <th style={{ padding: "14px 8px", fontWeight: 800 }}>최고점수</th>
                  </tr>
                </thead>
                <tbody>
                  {bowlingRanking.length === 0 ? (
                    <tr>
                      <td colSpan={9} style={{ 
                        textAlign: "center", 
                        color: "#94a3b8", 
                        padding: 40,
                        fontSize: 16
                      }}>
                        <div style={{ fontSize: 48, marginBottom: 12 }}>🎳</div>
                        등록된 볼링 선수가 없습니다.
                      </td>
                    </tr>
                  ) : (
                    bowlingRanking.map((row, i) => (
                      <tr
                        key={row.id}
                        id={row.id === myId ? "myRankingRow" : undefined}
                        style={{
                          textAlign: "center",
                          background: row.id === myId 
                            ? "linear-gradient(135deg, #fef3c7, #fbbf24)" 
                            : i % 2 ? "#f8fafc" : "#fff",
                          fontWeight: row.id === myId ? 700 : i < 3 ? 700 : 400,
                          color: row.id === myId 
                            ? "#92400e" 
                            : i === 0 ? "#d4af37" : i === 1 ? "#c0c0c0" : i === 2 ? "#cd7f32" : "#374151",
                          cursor: "pointer",
                          transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => {
                          if (row.id !== myId) {
                            e.currentTarget.style.backgroundColor = "#f1f5f9";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (row.id !== myId) {
                            e.currentTarget.style.backgroundColor = i % 2 ? "#f8fafc" : "#fff";
                          }
                        }}
                        onClick={() => navigate(`/mypage/${row.id}`)}
                      >
                        <td style={{ padding: "12px 8px", fontWeight: "inherit" }}>
                          {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `${i + 1}위`}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit" }}>
                          {row.nickname || '닉네임 없음'}
                          {row.id === myId && " (나)"}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit" }}>
                          {row.mmr >= 2000 ? "🔥 그랜드마스터" :
                           row.mmr >= 1800 ? "💎 다이아" :
                           row.mmr >= 1600 ? "🏆 플래티넘" :
                           row.mmr >= 1400 ? "🥇 골드" :
                           row.mmr >= 1200 ? "🥈 실버" : "🥉 브론즈"}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit", color: "#3b82f6" }}>
                          {row.mmr}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit", color: "#10b981" }}>
                          {row.win}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit", color: "#ef4444" }}>
                          {row.lose}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit" }}>
                          {row.totalGames > 0 ? Math.round((row.win / row.totalGames) * 100) : 0}%
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit" }}>
                          {row.averageScore}
                        </td>
                        <td style={{ padding: "12px 8px", fontWeight: "inherit", color: "#f59e0b" }}>
                          {row.highScore}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              {bowlingRanking.length > 0 && (
                <div style={{
                  textAlign: "center",
                  padding: "16px",
                  background: "#f8fafc",
                  color: "#64748b",
                  fontSize: 14,
                  borderRadius: "0 0 16px 16px"
                }}>
                  💡 닉네임을 클릭하면 해당 플레이어의 마이페이지로 이동합니다
                </div>
              )}
            </div>
          )}

          {/* 길드 랭킹 테이블 */}
          {selectedTab === "길드랭킹" && (
            <div>
              <div style={{
                background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                color: "#fff",
                padding: "16px 20px",
                borderRadius: "16px 16px 0 0",
                textAlign: "center",
                fontWeight: 700,
                fontSize: 18
              }}>
                🏰 길드 랭킹
              </div>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                background: "#fafcff",
                borderRadius: "0 0 16px 16px",
                overflow: "hidden",
                boxShadow: "0 4px 16px rgba(0,0,0,0.1)"
              }}>
                <thead>
                  <tr style={{ 
                    background: "linear-gradient(135deg, #f3e8ff, #ede9fe)", 
                    color: "#6b21a8" 
                  }}>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>순위</th>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>길드명</th>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>길드장</th>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>멤버 수</th>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>길드 점수</th>
                    <th style={{ padding: "14px 12px", fontWeight: 800 }}>소개</th>
                  </tr>
                </thead>
                <tbody>
                  {guildRanking.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ 
                        textAlign: "center", 
                        color: "#94a3b8", 
                        padding: 40,
                        fontSize: 16
                      }}>
                        <div style={{ fontSize: 48, marginBottom: 12 }}>🏰</div>
                        등록된 길드가 없습니다.
                      </td>
                    </tr>
                  ) : (
                    guildRanking.map((guild, i) => (
                      <tr
                        key={guild.id}
                        style={{
                          textAlign: "center",
                          background: i % 2 ? "#f8fafc" : "#fff",
                          fontWeight: i < 3 ? 700 : 400,
                          color: i === 0 ? "#d4af37" : i === 1 ? "#c0c0c0" : i === 2 ? "#cd7f32" : "#374151",
                          transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f1f5f9";
                          e.currentTarget.style.transform = "scale(1.01)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = i % 2 ? "#f8fafc" : "#fff";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <td style={{ padding: "12px", fontWeight: "inherit" }}>
                          {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `${i + 1}위`}
                        </td>
                        <td 
                          style={{ 
                            padding: "12px", 
                            fontWeight: "inherit",
                            color: "#3b82f6",
                            cursor: "pointer",
                            textDecoration: "underline"
                          }}
                          onClick={() => handleGuildClick(guild.id)}
                          onMouseEnter={(e) => {
                            e.target.style.color = "#1d4ed8";
                            e.target.style.fontWeight = "700";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = "#3b82f6";
                            e.target.style.fontWeight = "inherit";
                          }}
                        >
                          {guild.name}
                        </td>
                        <td style={{ padding: "12px", fontWeight: "inherit" }}>
                          {guild.leaderName || guild.leaderNickname || "미설정"}
                        </td>
                        <td style={{ padding: "12px", fontWeight: "inherit" }}>
                          {guild.memberCount}명
                        </td>
                        <td style={{ padding: "12px", fontWeight: "inherit", color: "#10b981" }}>
                          {guild.point || 0}점
                        </td>
                        <td style={{ 
                          padding: "12px", 
                          fontWeight: "inherit",
                          maxWidth: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}>
                          {guild.intro || guild.description || "소개글이 없습니다"}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              {guildRanking.length > 0 && (
                <div style={{
                  textAlign: "center",
                  padding: "16px",
                  background: "#f8fafc",
                  color: "#64748b",
                  fontSize: 14,
                  borderRadius: "0 0 16px 16px"
                }}>
                  💡 길드명을 클릭하면 해당 길드의 소개 페이지로 이동합니다
                </div>
              )}
            </div>
          )}
        </>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
        <button onClick={() => window.location.href = '/'} style={{ padding: '16px 40px', borderRadius: 24, background: '#10b981', color: '#fff', fontWeight: 800, fontSize: 20, border: 'none', cursor: 'pointer', boxShadow: '0 4px 16px #10b98133', letterSpacing: 1 }}>
          홈 화면으로 이동
        </button>
      </div>
    </div>
  );
}

export default Ranking;